<template>
  <div class="detailContainer">
    <div id="top">
      <div class="top boxcenter clearfix">
        <h1 class="fl">
          <img src="../../images/bxcp_cfLogo.png" />
        </h1>
        <div class="topNav fl">
          <a href="http://www.cfbond.com" target="_blank">中国财富网首页</a> >
          <router-link to="/">保险排行榜</router-link>
        </div>
      </div>

      <div class="m_top">
        <span @click="goBack"></span>
        <h1>{{detailConn.company_name}}</h1>
      </div>
    </div>
    <div id="banner">
      <div class="banner boxcenter clearfix">
        <div class="bannerL fl">
          <img class="bxcpLogo" :src="logo" />
        </div>
        <div class="bannerR fl">
          <p class="bxcpName">{{detailConn.company_name}}</p>
          <p class="companyName">{{detailConn.insurance_name}}</p>
        </div>
      </div>
      <div class="bannerNav">
        <ul class="boxcenter">
          <li class="on">
            <a href="#cppj">产品评级</a>
          </li>
          <li>
            <a href="#jcxx">基础信息</a>
          </li>
          <li>
            <a href="#bxzr">保险责任</a>
          </li>
          <li>
            <a href="#cptk">产品条款</a>
          </li>
        </ul>
      </div>
    </div>
    <div id="main">
      <div class="main boxcenter clearfix">
        <div class="mainL fl">
          <div class="mainLConn" id="cppj">
            <h3>产品评级</h3>
            <div class="mainLConnDetail clearfix" v-if="detailConn">
              <p class="fl">
                综合评级：
                <img
                  class="bxcpStar1"
                  :src="'http://www.cfbond.com/static/images/sybx_star('+(ProductRating[0].strVal).replace(/[\r\n]/g,).length+').png'"
                />
              </p>
              <p class="fl">
                价格评级：
                <img
                  class="bxcpStar2"
                  :src="'http://www.cfbond.com/static/images/sybx_star('+(ProductRating[1].strVal).replace(/[\r\n]/g,).length+').png'"
                />
              </p>
              <a
                class="fl"
                href="http://insurance.cfbond.com/ranking/instruction.html"
                target="_blank"
              >
                <span>评级说明</span>
              </a>
            </div>
          </div>
          <div class="mainLConn" id="jcxx">
            <h3>基础信息</h3>
            <div class="mainLConnDetail clearfix" v-if="detailConn">
              <p
                v-for="(item,index) in detailConn.data.BasicInformation"
                :key="index"
                class="fl"
                v-show="(item.strVal!= null) && (item.strVal!= '') "
              >
                <label>{{item.subDutyName}}：</label>
                <span>{{item.strVal}}</span>
              </p>
            </div>
          </div>
          <div class="mainLConn" id="bxzr">
            <h3>保险责任</h3>
            <div class="mainLConnDetail mainLConnDetailLast clearfix dn">
              <p class="NumberDisclaimers">
                *免责条款数量：
                <span></span>
              </p>
              <p>以上仅供参考，实际以保险条款为准</p>
            </div>
            <div
              ref="dutyTab"
              class="mainLConnDetail clearfix"
              :class="'mainLConnDetail'+index"
              v-for="(item,index) in InsuranceDuty"
              :key="index"
            >
              <p class="bxzrTitle">{{item.value}}</p>
              <table border>
                <thead>
                  <tr>
                    <td>责任类型</td>
                    <td>责任赔付</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(itemConn,index) in item"
                    :key="index"
                    v-if="(itemConn.strVal!= null) && (itemConn.strVal!= '') "
                  >
                    <td>{{itemConn.subDutyName}}</td>
                    <td
                      v-html="itemConn.strVal!=null?itemConn.strVal.replace(/；/g,'；<br/>'):itemConn.strVal"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mainLConn" id="cptk">
            <h3>产品条款</h3>
            <div class="mainLConnDetail clearfix">
              <a
                v-for="(item,index) in showUrl"
                :key="index"
                :href="item.url"
                target="_blank"
              >{{item.name}}</a>
            </div>
          </div>
        </div>
        <div
          v-if="isPC"
          class="mainR fr"
          id="sideBar"
          ref="sideBar"
          :class="isFixed== true?'isFixed':''"
        >
          <div>
            <p class="pBox">2018中国人身保险产品研究报告（消费者版）</p>
            <div class="clearfix">
              <img class="fl" src="http://www.cfbond.com/static/images/wxgzh.jpg" />
              <p class="fr">
                关注官方微信
                <br />发送“人身保险”
                <br />即可下载
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="foot" class="boxcenter">
      <div class="foot">
        <fieldset>
          <legend>技术支持单位：北京爱选信息科技有限公司</legend>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      query: this.$route.query,
      detailConn: "",
      InsuranceDuty: [],
      ProductRating: [],
      //条款
      showUrl: [],
      isFixed: false,
      sidebarRight: "",
      //判断页面尺寸
      isPC: document.body.clientWidth > 768 ? true : false,
      logo: ""
    };
  },
  created() {
    this.getConn();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async getConn() {
      await this.axios
        .get("App.insurance_detail_ym.action", { params: this.query })
        .then(result => {
          this.detailConn = result.data;
          this.InsuranceDuty = result.data.data.InsuranceDuty;
          this.showUrl = result.data.data.ShowUrl;
          this.logo = result.data.data.logo_url;
          this.ProductRating = result.data.data.ProductRating;
          this.$nextTick(function() {
            this.$refs.dutyTab.forEach(item => {
              if ($(item).find("tbody tr").length == 0) {
                $(item).hide();
              }
            });
            if (this.isPC) {
              let barRight = document.getElementById("sideBar");
              this.sidebarRight =
                document.body.clientWidth -
                barRight.offsetWidth -
                barRight.offsetLeft;
              window.onresize = () => {
                this.sidebarRight =
                  document.body.clientWidth -
                  barRight.offsetWidth -
                  barRight.offsetLeft;
              };
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleScroll() {
      this.$nextTick(() => {
        if (this.isPC) {
          let scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let headerTop = document.getElementById("sideBar");
          if (scrollTop > 341) {
            this.isFixed = true;
            headerTop.style.right = this.sidebarRight + "px";
          } else {
            this.isFixed = false;
          }
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.detailContainer {
  background: #eee;
  color: #333;
}
#top {
  height: 51px;
  background: #ff800b;
  margin-top: 0;
  line-height: 51px;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}
#top h1 {
  margin-right: 47px;
}
#top .topNav {
  color: #ffd89b;
}
#top .topNav a {
  color: #ffd89b;
  font-size: 14px;
}
.m_top {
  display: none;
}

#banner {
  overflow: hidden;
  padding-top: 25px;
  max-width: 1920px;
  margin: 0 auto;
  height: 265px;
  background: url(../../images/bxcp_detail_bannerBG.png) no-repeat center;
  border-bottom: 1px solid #ff800b;
}
.banner {
  margin-bottom: 60px;
}
.banner .bannerL {
  width: 147px;
  margin-right: 40px;
}
.bannerL img {
  width: 147px;
}
.bannerR p.bxcpName {
  font-size: 22px;
  color: #333;
  font-weight: bold;
  line-height: 48px;
}
.bannerR p.companyName {
  font-size: 18px;
  color: #ff800b;
  line-height: 30px;
  margin-bottom: 30px;
}
.bannerR p.bxcpDescri {
  font-size: 16px;
  color: #333;
  line-height: 34px;
}
.bannerNav li {
  float: left;
  width: 160px;
  text-align: center;
  line-height: 66px;
  font-size: 18px;
}
.bannerNav li.on a {
  color: #ff800b;
}
.bannerNav li a:hover {
  color: #ff800b !important;
  text-decoration: none;
}

#main {
  margin-top: 1px;
}
.mainL {
  width: 900px;
  background: #fff;
  padding-top: 93px;
  padding-left: 46px;
}
.mainLConn h3 {
  height: 26px;
  line-height: 26px;
  border-left: 3px solid #ff800b;
  padding-left: 17px;
  font-size: 22px;
  margin-bottom: 24px;
}
.mainLConn {
  margin-bottom: 108px;
}
/*产品评级*/
#cppj .mainLConnDetail p {
  width: 250px;
  margin-right: 100px;
  line-height: 39px;
}
#cppj .mainLConnDetail a span {
  display: inline-block;
  width: 126px;
  height: 39px;
  text-align: center;
  line-height: 39px;
  background: #ff800b;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
}

/*基础信息*/
#jcxx .mainLConnDetail p {
  width: 400px;
  margin-bottom: 38px;
}
#jcxx .mainLConnDetail p label {
  float: left;
  display: block;
  width: 80px;
  font-weight: bold;
  text-align: right;
  margin-right: 20px;
}
#jcxx .mainLConnDetail p span {
  display: inline-block;
  width: 300px;
}

/*保险责任*/
#bxzr .mainLConnDetail {
  width: 565px;
}
#bxzr p.bxzrTitle {
  color: #ff800b;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  text-align: center;
}
#bxzr table {
  border-collapse: collapse;
  border-radius: 6px;
  border: 1px solid #dcc2ab;
  margin-bottom: 50px;
  width: 100%;
}
#bxzr table td {
  border: 1px solid #dcc2ab;
}
#bxzr table thead td {
  background: #f1e6dc;
  height: 54px;
  text-align: center;
}
#bxzr table thead td:first-child {
  width: 214px;
}
#bxzr table tr td:first-child {
  text-align: center;
}
#bxzr table tbody tr td:last-child {
  padding: 30px 20px;
}
p.NumberDisclaimers {
  color: #686868;
  margin-bottom: 30px;
}

/*产品条款*/
#cptk .mainLConnDetail {
  width: 790px;
  background: #fff9f3;
  padding: 20px 0 20px 65px;
  line-height: 40px;
}
#cptk .mainLConnDetail a {
  background: url(../../images/bxcp_tkBG.png) no-repeat left center;
  padding-left: 50px;
  display: block;
}

.mainR {
  width: 235px;
  height: 260px;
  background: #fff;
  padding: 30px 10px;
  text-align: center;
  box-sizing: border-box;
}
.isFixed {
  position: fixed;
  top: 0px;
  z-index: 4;
}
.mainR .pBox {
  border: 1px solid #e6e6e6;
  font-size: 16px;
  line-height: 36px;
  margin: 0;
  margin-bottom: 20px;
}
.mainR p {
  line-height: 30px;
  margin-bottom: 20px;
}
.mainR span {
  display: inline-block;
  width: 124px;
  height: 36px;
  line-height: 36px;
  color: #ff800b;
  border: 1px solid #ff800b;
  border-radius: 4px;
}
.mainR img {
  width: 115px;
  display: block;
}
.mainR p {
  font-size: 12px;
  margin: 15px 0;
}

#foot {
  height: 40px;
  padding: 50px 0;
}
.foot {
  width: 946px;
}
#foot fieldset {
  border-top: 1px solid #686868;
  width: 312px;
  line-height: 40px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  text-align: center;
}
#foot fieldset legend {
  padding: 0 10px;
}
@media screen and (min-width: 100px) and (max-width: 768px) {
  .detailContainer {
    width: 100%;
    overflow-x: hidden;
    min-width: 100%;
    max-width: 100%;
    background: #f2f2f2;
  }
  li {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }
  .boxcenter {
    width: 100%;
    margin: 0 auto;
  }
  #top {
    height: 44px;
  }
  .top {
    display: none;
  }
  .m_top {
    display: block;
    height: 44px;
    line-height: 44px;
    background: #ffa33b;
    color: #fff;
    text-align: center;
    position: relative;
    margin-bottom: 1px;
  }
  #top .m_top h1 {
    font-size: 20px;
    margin: 0 auto;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .m_top span {
    position: absolute;
    left: 35px;
    top: 12px;
    display: block;
    width: 12px;
    height: 21px;
    background: url(../../images/bxcp_back.png) no-repeat;
    background-size: 100% 100%;
  }
  .m_top span a {
    display: block;
    width: 100%;
    height: 100%;
  }
  #banner {
    height: 100px;
    background: #fff;
    margin-bottom: 10px;
    padding: 18px 0;
    border-bottom: 0;
  }
  .banner {
    height: 100%;
  }
  .banner .bannerL {
    width: 26%;
    margin: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .banner .bannerL img {
    width: 80%;
  }
  .banner .bannerR {
    width: 70%;
  }
  .banner .bannerR .bxcpName {
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .banner .bannerR .companyName {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .bannerNav {
    display: none;
  }

  .mainL {
    width: 100%;
    float: none;
    padding: 0;
    background: #fff;
    padding-top: 8px;
  }
  .mainLConn {
    margin-bottom: 30px;
  }
  .mainLConn h3 {
    height: 15px;
    margin: 9px 0;
    font-size: 15px;
    line-height: 15px;
    margin-left: 15px;
  }
  .mainLConnDetail {
    border-top: 1px solid #e6e6e6;
    padding-left: 15px;
    position: relative;
    padding-top: 10px;
  }
  .mainLConnDetail p {
    font-size: 12px;
  }
  #cppj .mainLConnDetail a {
    position: absolute;
    right: 60px;
    top: 35px;
  }
  #cppj .mainLConnDetail a span {
    width: 78px;
    height: 23px;
    line-height: 23px;
    font-size: 12px;
  }

  #jcxx .mainLConnDetail p {
    width: 100%;
    line-height: 30px;
    margin-bottom: 0;
  }
  #jcxx .mainLConnDetail p span {
    width: auto;
  }

  #bxzr .mainLConnDetail {
    width: 90%;
    padding: 0 5%;
  }
  #bxzr table {
    margin-bottom: 20px;
  }
  #bxzr table thead td:first-child {
    width: 30%;
  }
  #bxzr table tbody tr td:last-child {
    padding: 10px;
  }
  #bxzr p.bxzrTitle {
    font-size: 15px;
  }
  #bxzr table tr td,
  p.NumberDisclaimers {
    font-size: 14px;
  }
  #bxzr .mainLConnDetail {
    border-top: 0;
  }
  #cptk .mainLConnDetail {
    width: 90%;
    padding: 20px 5%;
    background: none;
  }
  #cptk .mainLConnDetail a {
    line-height: 24px;
    padding: 10px 0 10px 30px;
    font-size: 14px;
  }
  .mainR,
  #foot {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/detail/detail.vue